import { Wizard } from "src/app/core/wizard/wizard";
import { MapSearchPdfPageComponent } from "../map-search-pdf-page/map-search-pdf-page.component";
import { Injectable } from "@angular/core";
import { CaptureDescriptionPageComponent } from "../capture-description-wizard/capture-description-page/capture-description-page.component";

@Injectable({
  providedIn: 'root'
})
export class MapSearchPdfWizard extends Wizard<any> {
  key = 'map-search-pdf';
  pageTypeMap = {
    'map-search-pdf': MapSearchPdfPageComponent,
    'capture-description-page': CaptureDescriptionPageComponent
  };

  startingPageKey = 'map-search-pdf';

  constructor() {
    super();
    this.width = 612;
    // Apply off-screen positioning
    // setTimeout(() => {
    //   const dialogElement = document.querySelector('.mat-dialog-container');
    //   if (dialogElement) {
    //     (dialogElement as HTMLElement).setAttribute('style', 'position: absolute; left: -9999px; top: -9999px;');
    //   }
    // }, 0);
  }
}